// frontend/src/tour/steps/team-chat.steps.js
// Team Chat tour: channels (hamburger/panel) + quick @ mention.

export const TEAM_CHAT_TOUR_STEPS = () => [
  {
    id: "team-chat-channels",
    selector: '[data-tour="team-chat-channels"]',
    placement: "right",
    title: "Channels",
    content:
      "Team Chat is where you message your team in channels. Use this menu to switch between channels (e.g. General, Sales, Support) and see members. On mobile, tap the menu icon to open the channel list.",
  },
  {
    id: "team-chat-quick-mention",
    selector: '[data-tour="team-chat-quick-mention"]',
    placement: "top",
    title: "Quick @ Mention",
    content:
      "Type @ in the message box to mention a teammate or @everyone. A list appears so you can pick who to notify; they'll get a notification so they don't miss your message.",
  },
];

/**
 * Versioned "new only" tour for Team Chat.
 * Add steps here when you ship new features; bump the key (e.g. v1_7_team_chat_new_complete) when you add more.
 */
export const TEAM_CHAT_NEW_STEPS = () => [];
